import Grid from '@mui/material/Grid';

export const CustomGrid = Grid;

export default CustomGrid;
